<mat-card appearance="outlined" data-card="child-po-form">
  <mat-card-title>
    Add New Child Purchase Order for Po Number: {{ poNumber }}
  </mat-card-title>

  <mat-card-content>
    <form [formGroup]="addChildPurchaseOrderForm" novalidate>
      <!-- Basic Info Row -->
      <div class="row" data-section="basic-info">
        <!-- Po Number -->
        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4">
          <mat-form-field color="accent" data-field="poNumber">
            <mat-label>Po Number</mat-label>
            <input
              matInput
              id="poNumber"
              name="poNumber"
              type="text"
              autocomplete="off"
              maxlength="50"
              appInputValidator
              [sanitizeScriptTags]="true"
              formControlName="poNumber"
              tabindex="0"
              aria-label="PO Number"
              data-field="poNumber"
            />
            <mat-error *ngIf="addChildPurchaseOrderForm.get('poNumber').hasError('required') && addChildPurchaseOrderForm.get('poNumber').touched">
              Po number is required.
            </mat-error>
            <mat-error *ngIf="addChildPurchaseOrderForm.get('poNumber').hasError('maxlength')">
              Po number cannot be more than 50 characters.
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Order Date -->
        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4">
          <mat-form-field color="accent" data-field="orderDate">
            <mat-label>Order Date</mat-label>
            <input
              matInput
              [matDatepicker]="picker1"
              [max]="today"
              name="orderDate"
              readonly
              formControlName="orderDate"
              aria-describedby="date-format"
            />
            <mat-hint id="date-format">DD/MM/YYYY</mat-hint>
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
            <mat-error *ngIf="addChildPurchaseOrderForm.get('orderDate').hasError('required')">
              Order Date is required.
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Vendor -->
        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4">
          <mat-form-field color="accent" *ngIf="vendorOptions.length > 0">
            <mat-label>Vendor</mat-label>
            <mat-select formControlName="vendorCode" [disabled]="vendorOptions.length === 0">
              <mat-option value="">Select an option</mat-option>
              <mat-option *ngFor="let vendor of vendorOptions; let i = index" [value]="vendor.vendorCode">
                {{ vendor.vendorCode }} | {{ vendor.vendorName }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="addChildPurchaseOrderForm.get('vendorCode').touched && addChildPurchaseOrderForm.get('vendorCode').hasError('required')">
              Vendor Code is required.
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <!-- Description & Address Row -->
      <div class="row" data-section="description-address">
        <!-- Description -->
        <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 col-xxl-1">
          <mat-form-field color="accent">
            <mat-label>Description</mat-label>
            <input
              matInput
              name="description"
              id="description"
              autocomplete="off"
              formControlName="description"
              maxlength="100"
              [sanitizeScriptTags]="true"
              [hasAtLeastOneAlphabet]="true"
              appInputValidator
            />
            <mat-error *ngIf="addChildPurchaseOrderForm.get('description').hasError('maxlength')">
              Description cannot be more than 100 characters.
            </mat-error>
            <mat-error *ngIf="addChildPurchaseOrderForm.get('description').hasError('noAlphabet')">
              Must contain at least one alphabet character.
            </mat-error>
            <mat-error *ngIf="addChildPurchaseOrderForm.get('description').hasError('required')">
              Description is required.
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Address -->
        <div class="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 col-xxl-8">
          <mat-form-field color="accent">
            <mat-label>Address</mat-label>
            <input
              matInput
              id="address"
              name="address"
              autocomplete="off"
              formControlName="address"
              maxlength="250"
              [sanitizeScriptTags]="true"
              [hasAtLeastOneAlphabet]="true"
              appInputValidator
            />
            <mat-error *ngIf="addChildPurchaseOrderForm.get('address').hasError('maxlength')">
              Address cannot be more than 250 characters.
            </mat-error>
            <mat-error *ngIf="addChildPurchaseOrderForm.get('address').hasError('required')">
              Address is required.
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <!-- Expansion Panel for Details -->
      <div class="row" data-section="po-details">
        <div class="col-12">
          <mat-accordion formArrayName="ChildPurchaseOrderDetails">
            <mat-expansion-panel
              *ngFor="let item of addChildPurchaseOrderForm.get('ChildPurchaseOrderDetails')['controls']; let i = index; first as isFirst"
              [formGroupName]="i"
              [expanded]="isFirst"
            >
              <mat-expansion-panel-header>
                <mat-panel-title><mat-icon>apps</mat-icon> #{{ i + 1 }}</mat-panel-title>
              </mat-expansion-panel-header>

              <div class="row">
                <!-- Product -->
                <div class="col-md-4">
                  <mat-form-field color="accent">
                    <mat-label>Products</mat-label>
                    <mat-select formControlName="productId" (selectionChange)="onProductSelectionchange($event)">
                      <mat-option value="">Select an option</mat-option>
                      <mat-option *ngFor="let product of productOptions" [value]="product.productId">
                        {{ product.productName }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="item.get('productId').hasError('required')">
                      Product is required.
                    </mat-error>
                  </mat-form-field>
                </div>

                <!-- Category -->
                <div class="col-md-4">
                  <mat-form-field color="accent">
                    <mat-label>Product categories</mat-label>
                    <mat-select formControlName="categoryId" (selectionChange)="onCategorySelectionchange($event)">
                      <mat-option [value]="null">Select an option</mat-option>
                      <mat-option *ngFor="let cat of categoryOptions" [value]="cat.categoryId">
                        {{ cat.productCategoryName }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="item.get('categoryId').hasError('required')">
                      Category is required.
                    </mat-error>
                  </mat-form-field>
                </div>

                <!-- Subcategory -->
                <div class="col-md-4">
                  <mat-form-field color="accent">
                    <mat-label>Product Sub Categories</mat-label>
                    <mat-select formControlName="subcategoryId">
                      <mat-option [value]="null">Select an option</mat-option>
                      <mat-option *ngFor="let sub of subCategoryOptions" [value]="sub.subCategoryId">
                        {{ sub.subCategoryName }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="item.get('subcategoryId').hasError('required')">
                      Subcategory is required.
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <!-- Brand -->
                <div class="col-md-3">
                  <mat-form-field color="accent">
                    <mat-label>Brand</mat-label>
                    <mat-select formControlName="brandId">
                      <mat-option value="">Select an option</mat-option>
                      <mat-option *ngFor="let brand of brandOptions" [value]="brand.brandId">
                        {{ brand.brandName }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="item.get('brandId').hasError('required')">
                      Brand is required.
                    </mat-error>
                  </mat-form-field>
                </div>

                <!-- Order Quantity -->
                <div class="col-md-2">
                  <mat-form-field color="accent">
                    <mat-label>Order Qty</mat-label>
                    <input
                      matInput
                      type="number"
                      min="1"
                      max="90000"
                      formControlName="orderQuantity"
                      appInputValidator
                      [allowNumbersOnly]="true"
                      required
                    />
                    <mat-error *ngIf="item.get('orderQuantity').hasError('max') && item.get('orderQuantity').touched">
                      Must be less than 90000.
                    </mat-error>
                    <mat-error *ngIf="item.get('orderQuantity').hasError('min') && item.get('orderQuantity').touched">
                      Must be 1 or greater.
                    </mat-error>
                    <mat-error *ngIf="item.get('orderQuantity').hasError('required') && item.get('orderQuantity').touched">
                      Order Quantity is required.
                    </mat-error>
                  </mat-form-field>
                </div>

                <!-- UOM -->
                <div class="col-md-2">
                  <mat-form-field color="accent">
                    <mat-label>UOM</mat-label>
                    <mat-select formControlName="measuringUnitId">
                      <mat-option [value]="null">Select an option</mat-option>
                      <mat-option *ngFor="let unit of measuringOptions" [value]="unit.measuringUnitId">
                        {{ unit.unitName }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="item.get('measuringUnitId').hasError('required')">
                      Unit Name is required.
                    </mat-error>
                  </mat-form-field>
                </div>

                <!-- Warranty -->
                <div class="col-md-2">
                  <mat-form-field color="accent">
                    <mat-label>Warranty In Months</mat-label>
                    <input
                      matInput
                      type="number"
                      min="0"
                      max="60"
                      formControlName="warrantyInMonths"
                      appInputValidator
                      [allowNumbersOnly]="true"
                      required
                    />
                    <mat-error *ngIf="item.get('warrantyInMonths').hasError('max')">
                      Must be ≤ 60.
                    </mat-error>
                    <mat-error *ngIf="item.get('warrantyInMonths').hasError('min')">
                      Must be ≥ 0.
                    </mat-error>
                    <mat-error *ngIf="item.get('warrantyInMonths').hasError('required')">
                      Warranty is required.
                    </mat-error>
                  </mat-form-field>
                </div>

                <!-- Unit Price -->
                <div class="col-md-2">
                  <mat-form-field color="accent">
                    <mat-label>Unit Price</mat-label>
                    <input
                      matInput
                      type="number"
                      min="0"
                      max="2000000"
                      formControlName="unitPrice"
                      appInputValidator
                      [allowNumbersOnly]="true"
                      required
                    />
                    <mat-error *ngIf="item.get('unitPrice').hasError('required')">
                      Unit Price is required.
                    </mat-error>
                    <mat-error *ngIf="item.get('unitPrice').hasError('min')">
                      Must be ≥ 0.
                    </mat-error>
                    <mat-error *ngIf="item.get('unitPrice').hasError('max')">
                      Must be ≤ 2000000.
                    </mat-error>
                  </mat-form-field>
                </div>

                <!-- Remove Button -->
                <div class="col-md-1 text-center">
                  <button
                    mat-fab
                    type="button"
                    (click)="onRemoveDetailItem(i)"
                    [disabled]="addChildPurchaseOrderForm.get('ChildPurchaseOrderDetails').length === 1"
                  >
                    <mat-icon>remove_from_queue</mat-icon>
                  </button>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
    </form>
  </mat-card-content>

  <!-- Actions -->
  <mat-card-actions align="end">
    <button
      mat-raised-button
      class="custom-btn"
      type="button"
      [disabled]="!addChildPurchaseOrderForm.valid || measuringOptions.length === 0 || !isAdminGroupUser"
      (click)="saveChildPurchaseOrder()"
      matTooltip="Save Child Purchase Order"
    >
      <i class="material-icons" style="font-size: 30px">save</i>
    </button>
    <button
      mat-raised-button
      class="custom-btn"
      type="button"
      [disabled]="!addChildPurchaseOrderForm.valid || !isAdminGroupUser"
      (click)="addDetailItem()"
      matTooltip="Add More Purchase Details"
    >
      <i class="material-icons" style="font-size: 30px">queue</i>
    </button>
    <button
      mat-raised-button
      class="btn btn-rose"
      type="button"
      (click)="closechild()"
      matTooltip="Close Form."
    >
      <i class="material-icons" style="font-size: 30px">close</i>
    </button>
  </mat-card-actions>

  <mat-card-footer></mat-card-footer>
</mat-card>
